// Bundled, optimized responsive WebP media (content-hashed by the build → long cache).
// Replaces the oversized external JPEGs. Visuals unchanged; served responsively per viewport.
import heroDroplet640 from "@/assets/heroDroplet-640.webp";
import heroDroplet1264 from "@/assets/heroDroplet-1264.webp";
import jug189_424 from "@/assets/jug189-424.webp";
import jug189_848 from "@/assets/jug189-848.webp";
import jug11_424 from "@/assets/jug11-424.webp";
import jug11_848 from "@/assets/jug11-848.webp";
import business500 from "@/assets/business-500.webp";
import business1000 from "@/assets/business-1000.webp";
import ottawa960 from "@/assets/ottawa-960.webp";
import ottawa1600 from "@/assets/ottawa-1600.webp";
import aquahero960 from "@/assets/aquahero-960.webp";
import aquahero1600 from "@/assets/aquahero-1600.webp";
import ottawahero800 from "@/assets/ottawahero-800.webp";
import ottawahero960 from "@/assets/ottawahero-960.webp";
import ottawahero1600 from "@/assets/ottawahero-1600.webp";
import odessaBottles from "@/assets/odessa-bottles.webp";
import odessa18l from "@/assets/odessa-18l.webp";
import odessa18l240 from "@/assets/odessa-18l-240.webp";
import odessa11l from "@/assets/odessa-11l.webp";
import van1_960 from "@/assets/van1-960.webp";
import van1_1600 from "@/assets/van1-1600.webp";
import van2_960 from "@/assets/van2-960.webp";
import van2_1600 from "@/assets/van2-1600.webp";
import van3_960 from "@/assets/van3-960.webp";
import van3_1600 from "@/assets/van3-1600.webp";

export const MEDIA = {
  aquaHero: { src: aquahero1600, srcSet: `${aquahero960} 960w, ${aquahero1600} 1600w` },
  ottawaHero: { src: ottawahero1600, srcSet: `${ottawahero800} 800w, ${ottawahero960} 960w, ${ottawahero1600} 1600w` },
  odessaBottles: { src: odessaBottles },
  odessa18l: { src: odessa18l, srcSet: `${odessa18l240} 240w, ${odessa18l} 329w` },
  odessa11l: { src: odessa11l },
  van1: { src: van1_1600, srcSet: `${van1_960} 960w, ${van1_1600} 1600w` },
  van2: { src: van2_1600, srcSet: `${van2_960} 960w, ${van2_1600} 1600w` },
  van3: { src: van3_1600, srcSet: `${van3_960} 960w, ${van3_1600} 1600w` },
  heroDroplet: {
    src: heroDroplet1264,
    srcSet: `${heroDroplet640} 640w, ${heroDroplet1264} 1264w`,
  },
  jug189: {
    src: jug189_848,
    srcSet: `${jug189_424} 424w, ${jug189_848} 848w`,
  },
  jug11: {
    src: jug11_848,
    srcSet: `${jug11_424} 424w, ${jug11_848} 848w`,
  },
  business: {
    src: business1000,
    srcSet: `${business500} 500w, ${business1000} 1000w`,
  },
  ottawa: {
    src: ottawa1600,
    srcSet: `${ottawa960} 960w, ${ottawa1600} 1600w`,
  },
};
